module.exports = __webpack_public_path__ + "img/1573119793.a70190dc.jpg";